import { SecondNativeArticleCampaign } from '@/types/secondNativeArticleCampaign';
import axios from 'lib/data/axios';
import { getSite } from 'lib/utils';
import getUrl from 'lib/utils/getUrl';

export const getSecondNativeArticleCampaigns = async (
  articleCategory: string
): Promise<SecondNativeArticleCampaign[]> => {
  const url = getUrl('api/native-article-campaigns');

  if (!url) {
    return [];
  }

  const brand = getSite();

  const response = await axios.get(url.href);
  const data = ((response?.data as SecondNativeArticleCampaign[]) ?? []).filter((item) =>
    item.categories.includes(`${articleCategory}-${brand}`)
  );
  return data;
};
